import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import GaugeChart from "../generic/GaugePercentChart";
import { getLastWeek } from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const GaugeChartContactsWithNbaLastWeek: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [contactsLastWeek, setContactsLastWeek] = useState<number>();
  const [
    contactsWithNbaLastWeek,
    setContactsWithNbaLastWeek,
  ] = useState<number>();

  const { lastWeek, yearLastWeek, weekRangeString } = getLastWeek();

  useEffect(() => {
    const now = moment();
    const dataLastWeek = customerContacts.countPerInterval.find((interval) => {
      const d = moment(interval.date);
      return d.isoWeek() === lastWeek && d.isoWeekYear() === yearLastWeek;
    });
    if (dataLastWeek) {
      setContactsLastWeek(dataLastWeek.count);
      setContactsWithNbaLastWeek(dataLastWeek.countWithNba);
    }
  }, [customerContacts, lastWeek, yearLastWeek]);
  return (
    <GaugeChart
      value={contactsWithNbaLastWeek}
      maxValue={contactsLastWeek}
      title={`Vergangene Woche (${weekRangeString})`}
      labelMaxValue="Kontakte vergangene Woche"
    />
  );
};

export default GaugeChartContactsWithNbaLastWeek;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/GaugeChartContactsWithNbaLastWeek.tsx